import { createBlock } from 'factories/block';
import { InteractionProps, reverse } from './interaction';
import { createLayout } from 'factories/layout';
import { createContinueBtn } from './continueBtn';
import { createFeedbackBlock } from './feedback';
import { createMediaBlock } from './media';

const contentForColumn = (count: number, sharedQuestionMedia) => (
  i: number
) => {
  return [
    () =>
      createBlock('ColumnContent', [
        createMediaBlock({
          child: 1,
        }),
        sharedQuestionMedia,
      ]),

    () =>
      createBlock('InteractionColumn', [
        createBlock('Slider', [
          sharedQuestionMedia,
          createBlock('Text'),
          createBlock('Text'),
          createFeedbackBlock({ label: 'Submit' }),
        ]),
        createMediaBlock({
          child: 0,
          isAdditionalMedia: true,
        }),
      ]),
  ][i];
};

export const createSliderInteractionBlock = props => {
  const sharedQuestionMedia = createMediaBlock({ child: 0 });

  return createBlock(
    'Interaction',
    [
      createLayout(contentForColumn(0, sharedQuestionMedia), 0, true),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn({})], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        name: props.name,
        style: props.style,
      },
      meta: {
        subType: 'Slider',
        layout: 'OneColumnReversed',
      },
    }
  );
};

export const interactionConfig = {};
